import { AxiosResponse } from 'axios'
import {
  GlobalProductInterface,
  GlobalProductsListParams,
  GlobalProductUpsertPayload,
  GlobalVariantInterface,
  GlobalVariantUpsertPayload,
} from '@/models/shop/GlobalProduct.types'
import axios from '@/services/axios'

const SHOP_ROUTE = process.env.VUE_APP_SHOP_V2_BASE_URI

export default abstract class GlobalProductsApi {
  public static baseRoute = `${SHOP_ROUTE}/global-catalog`
  public static entity = 'products'

  public static get route(): string {
    return `${this.baseRoute}/${this.entity}`
  }

  public static async list(params: GlobalProductsListParams): Promise<
    AxiosResponse<{
      data: GlobalProductInterface[]
      metadata: { count: number; page: number; size: number; sort: string }
    }>
  > {
    const url = `${this.route}`
    return await axios.get(url, { params })
  }

  public static async create(
    data: GlobalProductUpsertPayload,
  ): Promise<AxiosResponse<GlobalProductInterface>> {
    const url = `${this.route}`
    return await axios.post(url, data)
  }

  public static async get(
    id: string,
  ): Promise<AxiosResponse<GlobalProductInterface>> {
    const url = `${this.route}/${id}`
    return await axios.get(url)
  }

  public static async update(
    id: string,
    data: GlobalProductUpsertPayload,
  ): Promise<AxiosResponse<GlobalProductInterface>> {
    const url = `${this.route}/${id}`
    return await axios.patch(url, data)
  }

  public static async delete(id: string): Promise<AxiosResponse<void>> {
    const url = `${this.route}/${id}`
    return await axios.delete(url)
  }

  public static async createVariant(
    id: string,
    data: GlobalVariantUpsertPayload,
  ): Promise<AxiosResponse<GlobalVariantInterface>> {
    const url = `${this.route}/${id}/variants`
    return await axios.post(url, data)
  }

  public static async getVariant(
    id: string,
    variantId: string,
  ): Promise<AxiosResponse<GlobalVariantInterface>> {
    const url = `${this.route}/${id}/variants/${variantId}`
    return await axios.get(url)
  }

  public static async updateVariant(
    id: string,
    variantId: string,
    data: GlobalVariantUpsertPayload,
  ): Promise<AxiosResponse<GlobalVariantInterface>> {
    const url = `${this.route}/${id}/variants/${variantId}`
    return await axios.patch(url, data)
  }

  public static async deleteVariant(
    id: string,
    variantId: string,
  ): Promise<AxiosResponse<void>> {
    const url = `${this.route}/${id}/variants/${variantId}`
    return await axios.delete(url)
  }
}
